import type { Store } from '@reduxjs/toolkit';

import type { RootState } from 'app/store';
import { setUserMerchantPreferencesResolver } from 'utils/user-merchant-metadata/userMerchantMetadata';
import { resolveUserMerchantPreferencesScope } from 'utils/userMerchantPreferencesScope';

// ==============================|| USER MERCHANT PREFERENCES RESOLVER ||============================== //

export function installUserMerchantPreferencesResolver(store: Pick<Store<RootState>, 'getState'>): void {
  setUserMerchantPreferencesResolver(() => {
    const { auth, merchant } = store.getState();
    return resolveUserMerchantPreferencesScope({ user: auth.user, merchantId: merchant.merchant?.id });
  });
}
